module.exports = __webpack_public_path__ + "img/personelicon.73e0e162.png";